import { useEffect, useState } from "react";
import { RootStateType, IRestrictions } from "@Interfaces";
import { useSelector } from "react-redux";

const useRestrictions = (): [string?, IRestrictions?] => {
    const { restrictions: userRestrictions, account_type: userAccountType } =
        useSelector((state: RootStateType) => state.auth.user);

    const [accountType, setAccountType] = useState(userAccountType);
    const [restrictions, setRestrictions] = useState(userRestrictions);

    useEffect(() => {
        setAccountType(userAccountType);
        if (userRestrictions) {
            setRestrictions(userRestrictions);
        }
    }, [userAccountType, userRestrictions]);
    return [accountType, restrictions];
};

export default useRestrictions;
